<div class="info-page">
  <div class="info-nav">
    <ciao-help-search />

    <ng-template ngFor let-mainLink [ngForOf]="MainSidebar">
        <div class="link-section">
          <div
            class="section-title"
            [ngClass]="{ active: navCurrentSection == mainLink.href }"
          >
            <a [routerLink]="mainLink.href">
              {{ mainLink.title }}
            </a>
          </div>

          <!-- The section's own pages, nested under it while you're in it -->
          <div
            class="expandable-sub-section"
            *ngIf="subLinksFor(mainLink).length"
            [class.active]="isSectionExpanded(mainLink)"
          >
            <ng-container *ngFor="let item of subLinksFor(mainLink)">
              <span class="sub-section-header" *ngIf="item.type === 'header'">
                {{ item.title }}
              </span>
              <ng-container *ngIf="item.type === 'link'">
                <a
                  *ngIf="!item.external"
                  [routerLink]="item.href"
                  [routerLinkActive]="'active-link'"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  {{ item.title }}
                </a>
                <a
                  *ngIf="item.external"
                  rel="noopener noreferrer"
                  target="_blank"
                  [href]="item.href"
                >
                  {{ item.title }}
                  <span
                    class="pdf-badge"
                    *ngIf="item.icon === 'pdf'"
                    aria-label="PDF"
                    >PDF</span
                  >
                </a>
              </ng-container>
            </ng-container>
          </div>
        </div>
      <hr />
    </ng-template>
  </div>

  <div class="info-content">
    <!-- The sidenav (and its search) is hidden on phones, so the search gets
         its own spot at the top of the page there. -->
    <div class="mobile-search">
      <ciao-help-search layout="page" inputId="help-search-mobile" />
    </div>

    <div class="breadcrumb">
      <ng-template
        ngFor
        let-crumb
        [ngForOf]="breadcrumbTrail"
        let-first="first"
      >
        <span class="divider" *ngIf="!first"> / </span>
        <a
          [routerLink]="crumb.href"
          [routerLinkActive]="'active-link'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ crumb.title }}
        </a>
      </ng-template>
    </div>
    <ng-container
      *ngIf="(currentTopic || currentSection)?.type?.startsWith('custom/'); else topicTemplate"
    >
      <ciao-faqs *ngIf="(currentTopic || currentSection).type === 'custom/faq'" />
      <ciao-version-history
        *ngIf="(currentTopic || currentSection).type === 'custom/versionHistory'"
      />
      <ciao-roles-permissions
        *ngIf="(currentTopic || currentSection).type === 'custom/rolesPermissions'"
      />
      <ciao-register-user-profile
        *ngIf="
          (currentTopic || currentSection).type === 'custom/registerUserProfile'
        "
      />
    </ng-container>
    <ng-template #topicTemplate>
      <div
        class="topic"
        *ngIf="currentTopic || currentSection as topic; else defaultMessage"
      >
        <!-- Topic pages carry their own title in the markdown, so the section
             name here would just be a second heading above it. -->
        <h1 *ngIf="!currentTopic">{{ currentSection.title }}</h1>
        <ng-container *ngIf="topic.type.startsWith('topic/')">
          <div class="resource-block" *ngIf="topic.type === 'topic/image'">
            <img class="resource" [src]="topic.src" [alt]="topic.alt" />
          </div>
          <div class="resource-block" *ngIf="topic.type === 'topic/video' && topic.src">
            <!--
            The videos are alternate resources to the KBAs and PDFs.
            We are not able to efficiently generate
              captioning and descriptions at this time.
            sonarlint(Web:S4084)
          -->
            <!-- //NOSONAR --><video
              class="resource"
              controls=""
              [poster]="topic.poster"
              [src]="topic.src"
            >
              {{ topic.alt }}
              Video Resource. See below for more information.
              <!-- This information is read by screenreaders -->
            </video>
          </div>
          <markdown
            class="resource-description"
            *ngIf="topic.description as description"
            [data]="description"
          >
          </markdown>

          <div class="need-more-help">
            <h4 class="need-more-help-title">Need More Help?</h4>
            <p>
              Visit the
              <a
                href="https://usdacts-myit.fed.onbmc.com/dwp/app/#/"
                rel="noopener noreferrer"
                target="_blank"
                >CEC Digital Workplace</a
              >
              to submit a Customer Help Desk ticket and view other CIAO KBAs.
            </p>
            <p>
              If you have feedback about current or suggested features, email
              <a href="mailto:sm.fs.ciao_feedback@usda.gov"
                >FS-CIAO Feedback</a
              >.
            </p>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #defaultMessage>Section not found</ng-template>
